import { BaseComponent } from '../../components/base-component'
import { CartDrawer } from './cart-drawer'
import { replaceNodeChildren } from '../../utils/dom'
import { $el, $elParent } from 'src/scripts/utils/utils'
import { CartItem } from '../cart'

const CART_DRAWER_SELECTOR = 'cart-drawer'
const CART_DRAWER_ITEM_SELECTOR = 'cart-drawer-items-block'

export class CartDrawerItemsBlock extends BaseComponent {
  mountComponent(): void {
    const cartDrawer: CartDrawer = $elParent(CART_DRAWER_SELECTOR, this)
    cartDrawer?.on('update-nodes', this.handleCartDrawerUpdate)
    cartDrawer?.on('purchase', this.handleCartDrawerPurschase)
  }

  unmountComponent(): void {
    const cartDrawer: CartDrawer = $elParent(CART_DRAWER_SELECTOR, this)
    cartDrawer?.off('update-nodes', this.handleCartDrawerUpdate)
    cartDrawer?.off('purchase', this.handleCartDrawerPurschase)
  }

  handleCartDrawerUpdate = ({ node, parsedState }): void => {
    replaceNodeChildren(
      this,
      $el(
        `${CART_DRAWER_ITEM_SELECTOR}[block-id="${this.getAttribute(
          'block-id',
        )}"]`,
        node,
      ),
    )

    console.log(
      'UPDATE CART DRAWER',
      $el(
        `${CART_DRAWER_ITEM_SELECTOR}[block-id="${this.getAttribute(
          'block-id',
        )}"]`,
        node,
      ),
    )

    if (parsedState && parsedState.quantity === 1) {
      const newItem: CartItem = $el(
        `cart-item[data-variant-id="${parsedState.id}"]`,
        this,
      )

      newItem.setCollapse(true)
    }
  }

  handleCartDrawerPurschase = async ({ parsedState }) => {
    const item: CartItem = $el(
      `cart-item[data-variant-id="${parsedState.id}"]`,
      this,
    )

    if (item && parsedState.quantity === 1) {
      await item?.showAsNew()
    }

    item?.showCheckmark()
  }
}
